<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.5 10.5h-9a.5.5 0 000 1h9a.5.5 0 000-1zM17 15.5h-5.5a.5.5 0 000 1H17a.5.5 0 000-1zM20.5 15.5h-1.29a.5.5 0 000 1h1.29a.5.5 0 000-1zM17 20.5h-5.5a.5.5 0 000 1H17a.5.5 0 000-1zM20.5 20.5h-1.29a.5.5 0 000 1h1.29a.5.5 0 000-1z"/><path d="M27.75 7a4 4 0 00-7.44-2H9a2 2 0 00-2 2v18a2 2 0 002 2h14a2 2 0 002-2V10.78A4 4 0 0027.75 7zM9 25V7h10.75A4 4 0 0023 10.92V25zm14.75-15a3 3 0 113-3 3 3 0 01-3 3z"/><path d="M25.25 6.5h-1v-1a.5.5 0 00-1 0v1h-1a.5.5 0 000 1h1v1a.5.5 0 001 0v-1h1a.5.5 0 000-1z"/></svg>